import { SUBMISSIONS, SUPPLIES, ADDITIONAL_ANALYSIS } from 'constants/apis';
import Fetch from 'helpers/fetch';

export const confirmJobsStatus = item => new Promise((resolve, reject) => {
  Fetch.Get(`${SUBMISSIONS}/${encodeURIComponent(item.SubmissionId)}/Status`)
    .then(resp => resp.json())
    .then(data => ({ Status: data.DataItem.Status, RequestStatus: data.DataItem.RequestStatus }))
    .then(data => (data.Status === item.Status && data.RequestStatus === item.RequestStatus ? resolve() : reject()))
    .catch(reject);
});

export const confirmSuppliesStatus = item => new Promise((resolve, reject) => {
  Fetch.Get(`${SUPPLIES}/${encodeURIComponent(item.OrderNumber)}?fields=status`)
    .then(resp => resp.json())
    .then(data => data.DataItem.Status)
    .then(Status => (Status === item.Status ? resolve() : reject()))
    .catch(reject);
});

export const confirmAAStatus = item => new Promise((resolve, reject) => {
  Fetch.Get(`${ADDITIONAL_ANALYSIS}/${encodeURIComponent(item.Id)}/Status`)
    .then(resp => resp.json())
    .then(data => data.DataItem.Status)
    .then(Status => (Status === item.Status ? resolve() : reject()))
    .catch(reject);
});



// WEBPACK FOOTER //
// ./src/helpers/confirmStatus.js